module.exports = __webpack_public_path__ + "img/ae07f4e.png";